import React, { useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useWeddingWizard } from "../../../context/WeddingWizardContext";

const phoneOk = (v) => {
  const s = String(v || "").trim();
  if (!s) return false; // required
  // Simple permissive check: digits-only length 7–20 (allow spaces/dashes/() and +)
  const digits = s.replace(/[^\d]/g, "");
  return digits.length >= 7 && digits.length <= 20;
};

export default function CustomerInfoStep() {
  const { state, setCustomer } = useWeddingWizard();
  const c = state.customer || {};

  const on = (k) => (e) => setCustomer({ [k]: e.target.value });
  const onBool = (k) => (e) => setCustomer({ [k]: !!e.target.checked });

  const primaryPhoneError = useMemo(() => !phoneOk(c.phone), [c.phone]);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Customer Information
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
        }}>
        <TextField
          label="First name"
          value={c.firstName || ""}
          onChange={on("firstName")}
          autoComplete="given-name"
          required
          fullWidth
        />
        <TextField
          label="Last name"
          value={c.lastName || ""}
          onChange={on("lastName")}
          autoComplete="family-name"
          required
          fullWidth
        />
        <TextField
          label="Email"
          type="email"
          value={c.email || ""}
          onChange={on("email")}
          autoComplete="email"
          required
          fullWidth
        />

        {/* PRIMARY — required */}
        <TextField
          label="Primary phone"
          value={c.phone || ""}
          onChange={on("phone")}
          autoComplete="tel"
          required
          error={primaryPhoneError}
          helperText={primaryPhoneError ? "Enter a valid phone number" : " "}
          fullWidth
        />

        {/* BACKUP — optional */}
        <TextField
          label="Backup phone (optional)"
          value={c.phoneSecondary || ""}
          onChange={on("phoneSecondary")}
          autoComplete="tel"
          placeholder="Coordinator / best man / etc."
          fullWidth
        />
        <TextField
          label="Whose number is the backup number?"
          value={c.phoneSecondaryLabel || ""}
          onChange={on("phoneSecondaryLabel")}
          placeholder="e.g. Wedding planner, Maid of Honor"
          fullWidth
        />
      </Box>

      <FormControlLabel
        sx={{ mt: 1 }}
        control={
          <Checkbox
            checked={!!c.marketingOptIn}
            onChange={onBool("marketingOptIn")}
          />
        }
        label="Keep me in the loop with occasional email updates and offers."
      />
    </Box>
  );
}
